import { useEffect } from "react";
import { ADMIN_CSV_READY_EVENT } from "../utils/adminCsvSocket";

/** Subscribe to admin_csv_ready socket events (dispatched as window CustomEvent). */
export function useAdminCsvReady(onReady, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled || typeof onReady !== "function") return undefined;

    const handler = (event) => {
      onReady(event?.detail || {});
    };

    window.addEventListener(ADMIN_CSV_READY_EVENT, handler);
    return () => window.removeEventListener(ADMIN_CSV_READY_EVENT, handler);
  }, [onReady, enabled]);
}
